<!-- MOBILE: -->
<app-mobile-header-secondary title="{{ 'menu.organization' | translate }}"> </app-mobile-header-secondary>

<!-- DESKTOP: -->

<article class="configuration-item">
  <div class="row mb-4">
    <div class="col-8">
      <div class="configuration-title mb-1">
        {{ 'settings.membersOf' | translate }} <span class="highlight">{{ currentUser?.organization?.name }}</span>
      </div>
      <div class="configuration-text">{{ 'settings.orgMembersSharePlanAndAdminPermissions' | translate }}</div>
    </div>
    <div class="col-4 d-flex justify-content-end">
      <button type="button" class="autentique-button" (click)="openInviteMembersModal()" *ngIf="currentUser?.currentPermissions.actions_members_oz">{{ 'settings.addUser' | translate }}</button>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-lg-6">
      <div class="d-inline-block">
        <app-switch-tabs
          [options]="[
            [false, translateService.instant('settings.accept')],
            [true, translateService.instant('settings.pending')]
          ]"
          [(ngModel)]="isShowingInvitations"
          [ngModelOptions]="{ standalone: true }"
        ></app-switch-tabs>
      </div>
    </div>
    <div class="col-lg-6 d-flex justify-content-end align-items-center">
      <span class="configuration-filter-text">{{ 'settings.filterBy' | translate }}</span>
      <div class="configuration-filter" appDropdown>
        <button type="button" class="configuration-filter-toggle dropdown__toggle-control dropdown__toggle-control--icon-end" appDropdownToggle>
          {{ selectedGroup ? selectedGroup.name : ('settings.all' | translate) }}
          <i class="fa-regular fa-chevron-down dropdown__toggle-chevron dropdown__toggle-icon--font-size-12"></i>
        </button>
        <div appDropdownMenu>
          <button type="button" appDropdownItem (click)="selectedGroup = null; loadData({ page: 1, search: searchQuery, group: null })">
            {{ 'settings.all' | translate }}
          </button>
          <button type="button" appDropdownItem *ngFor="let group of groups" (click)="selectedGroup = group; loadData({ page: 1, search: searchQuery, group: group })">
            {{ group.name }}
          </button>
        </div>
      </div>
      <app-search [(query)]="searchQuery" [theme]="'clean'" (queryChange)="pageNumber = 1; loadData({ page: 1, search: $event })"></app-search>
    </div>
  </div>

  <div class="row" *ngIf="currentUser && (isShowingInvitations ? invitations : members).length > 0">
    <div class="col-12">
      <table class="configuration-table">
        <thead class="head">
          <th class="col1">{{ 'settings.name' | translate }}</th>
          <th class="col2">{{ 'settings.individualPermissions' | translate }}</th>
          <th class="col2">{{ 'settings.group' | translate }}</th>
          <th class="col3"></th>
        </thead>
        <tbody class="body">
          <tr *ngFor="let member of isShowingInvitations ? invitations : members; let index = index">
            <td class="user">
              <div class="user-holder">
                <app-avatar [seed]="member.user?.email || member.user?.name || member.user?.phone"></app-avatar>
                <div class="user-info">
                  <p class="user-name">{{ member.user?.name }}</p>
                  <p class="user-contact">{{ member.user?.email || member.user?.phone }}</p>
                </div>
              </div>
            </td>
            <td class="highlight">
              <a
                href="javascript:void(0)"
                (click)="!isLoading && openEditPermissionsModal(member)"
                *ngIf="!isShowingInvitations && currentUser?.currentPermissions.actions_members_oz && !this.organizationService.isMemberAdmin(member)"
              >
                {{ (this.organizationService.isMemberAdmin(member) ? 'settings.admin' : hasFullAccess(member) ? 'settings.accessTotal' : 'settings.accessRestricted') | translate }}
              </a>
              <span *ngIf="isShowingInvitations || !currentUser?.currentPermissions.actions_members_oz || this.organizationService.isMemberAdmin(member)">
                {{ (this.organizationService.isMemberAdmin(member) ? 'settings.admin' : hasFullAccess(member) ? 'settings.accessTotal' : 'settings.accessRestricted') | translate }}
              </span>
            </td>
            <td class="highlight">
              <a href="javascript:void(0)" (click)="!isLoading && openEditGroupModal(member)" *ngIf="!isShowingInvitations && currentUser?.currentPermissions.actions_members_oz">
                {{ member.group?.name | truncate: 60 }}
              </a>
              <span *ngIf="isShowingInvitations || !currentUser?.currentPermissions.actions_members_oz">{{ member.group?.name | truncate: 60 }}</span>
            </td>
            <td class="opts">
              @if (currentUser?.currentPermissions?.actions_members_oz) {
                @if (!isShowingInvitations) {
                  <div appDropdown placement="bottom-right">
                    <button type="button" class="dropdown__toggle-control dropdown__toggle-control--icon-only" [id]="'options-dropdown-' + index" appDropdownToggle>
                      <i class="far fa-ellipsis-v"></i>
                    </button>

                    <div appDropdownMenu [attr.aria-labelledby]="'options-dropdown-' + index">
                      <button type="button" appDropdownItem (click)="openEditPermissionsModal(member)" [disabled]="isLoading || this.organizationService.isMemberAdmin(member)">
                        <i class="fa-regular fa-edit"></i>
                        {{ 'button.editPermissions' | translate }}
                      </button>

                      <button type="button" appDropdownItem (click)="openEditGroupModal(member)" [disabled]="isLoading">
                        <i class="fa-regular fa-edit"></i>
                        {{ 'button.editGroup' | translate }}
                      </button>

                      <button type="button" class="dropdown__item--danger" appDropdownItem (click)="deleteMember(member)" [disabled]="isLoading">
                        <i class="fa-regular fa-user-minus"></i>
                        {{ 'button.removeMember' | translate }}
                      </button>
                    </div>
                  </div>
                } @else {
                  <div class="dropdown-table" placement="bottom-right" container="body" ngbDropdown>
                    <label class="dropdown-table-toggle" [id]="'options-dropdown-' + index" ngbDropdownToggle><i class="fa-regular fa-ellipsis-v"></i></label>
                    <div [attr.aria-labelledby]="'options-dropdown-' + index" ngbDropdownMenu>
                      <button (click)="resendInvitation($any(member))" [disabled]="isLoading || invitationsResent.includes($any(member).id)" ngbDropdownItem>
                        {{ 'button.resendEmail' | translate }}
                      </button>
                      <button (click)="deleteMemberInvitation($any(member))" [disabled]="isLoading" ngbDropdownItem>{{ 'button.revokeInvite' | translate }}</button>
                    </div>
                  </div>
                }
              }
            </td>
          </tr>
        </tbody>
      </table>

      <div class="text-center mt-3" *ngIf="!isLoading && (isShowingInvitations ? !isInvitationsLastPage : !isLastPage)">
        <button type="button" class="btn btn-link" (click)="loadData({ page: (isShowingInvitations ? invitationsPageNumber : pageNumber) + 1, search: searchQuery, group: selectedGroup })">
          {{ 'button.loadMore' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="configuration-filtered-empty" *ngIf="!isShowingInvitations && currentUser && members.length === 0 && (searchQuery || selectedGroup)">
    <div class="configuration-filtered-empty_text">
      {{ 'settings.noMatchingOrgMembers' | translate }}
      <span *ngIf="selectedGroup"
        >"<strong>{{ selectedGroup.name }}</strong
        >"</span
      >
      <span *ngIf="searchQuery && selectedGroup">e</span>
      <span *ngIf="searchQuery"
        >"<strong>{{ searchQuery }}</strong
        >"</span
      >
    </div>
    <button type="button" class="default-button" (click)="searchQuery = ''; selectedGroup = null; loadMembers({ page: 1 })">{{ 'button.removeFilters' | translate }}</button>
  </div>
  <div class="configuration-filtered-empty" *ngIf="currentUser && (isShowingInvitations ? invitations.length === 0 : members.length === 0 && (searchQuery || selectedGroup))">
    <div class="configuration-filtered-empty_title">{{ 'settings.nothingHere' | translate }}</div>
  </div>
</article>
